"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigChart = void 0;
var withMName_1 = require("../../utils/withMName");
var Backbone = __importStar(require("backbone"));
var underscore_1 = __importDefault(require("underscore"));
var grouping_1 = require("../../grouping");
var charts_1 = require("../../charts");
var BigChart = /** @class */ (function (_super) {
    __extends(BigChart, _super);
    function BigChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigChart.prototype.events = function () {
        return {
            'change input[name=chart_type]': this.setChartType.mname,
            'change input[name=subseries]': this.setSubseries.mname
        };
    };
    BigChart.prototype.initialize = function () {
        underscore_1.default.bindAll(this, this.setChartType.mname, this.setSubseries.mname);
        this.descriptionContainer = $(this.$el.data('descriptionContainer'));
        this.sourceSelection = $(this.$el.data('sourceSelection'));
        this.reportContainer = $('.js-county-report');
        this.autocomplete = $(this.$el.data('municipalitySelect')).data('view');
        if (this.autocomplete) {
            var self_1 = this;
            this.autocomplete.$el.on('suggestion:clicked', function () { return self_1.onChangeMunicipality(); });
        }
        var bindList = 'change:factor change:compareTo change:type change:subseries';
        if (window.fromSwedenStatisticsPage || window.fromSwedenSurveyPage) {
            bindList += ' change:municipality ';
        }
        return this.model.bind(bindList, underscore_1.default.debounce(this.render, 200), this);
    };
    BigChart.prototype.onChangeMunicipality = function () {
        var muni = this.autocomplete.field.val();
        return this.model.set('municipality', muni);
    };
    BigChart.prototype.setChartType = function () {
        return this.model.set('type', this.$el.find('input[name=chart_type]:checked').val());
    };
    BigChart.prototype.setSubseries = function () {
        return this.model.set('subseries', this.$el.find('input[name=subseries]:checked').val());
    };
    BigChart.prototype.render = function () {
        this.updateDescription();
        this.updateChart();
        this.updateSourceSelection();
        this.updateReportContainer();
        return this;
    };
    BigChart.prototype.updateDescription = function () {
        if (!this.descriptionContainer) {
            return;
        }
        var factor = this.model.get('factor');
        var description = window.factorDescriptions[factor];
        var type = this.model.get('type');
        // Aaargh, sync with start_page_chart.js.coffee
        var hiddenGradingScaleCopy = [
            "knowledge_of_muni_work",
            "most_prioritized_actions",
            'crime_a_problem',
            'crime_change_2years',
            'crime_risk_kind',
            'company_relocate',
            'advice_on_permission',
            'business_climate_change_5_years',
            'municipality_runs_competing_businesses',
            'survey_contact_understanding', 'survey_contact_clearfee', 'survey_contact_handling',
            'survey_contact_reachable', 'survey_contact_digitized'
        ];
        if (underscore_1.default(hiddenGradingScaleCopy).includes(factor)) {
            $('#js-grading-scale-1-6').hide();
        }
        else {
            $('#js-grading-scale-1-6').show();
        }
        if (factor === 'crime_a_problem') {
            if (type === 'Politiker') {
                description = 'Upplever du att brottslighet är ett problem för företagen i din kommun?';
            }
            else {
                description = 'Upplever du att brottslighet är ett problem för ditt företag?';
            }
        }
        if (factor === 'crime_change_2years') {
            if (type === 'Politiker') {
                description = 'Hur upplever du att brottsligheten mot företag har förändrats i din kommun under de senaste två åren?';
            }
            else {
                description = 'Hur upplever du att brottsligheten mot ditt företag har förändrats under de senaste två åren?';
            }
        }
        return this.descriptionContainer.html(description);
    };
    BigChart.prototype.updateReportContainer = function () {
        var _a, _b, _c;
        if (!this.reportContainer) {
            return;
        }
        var factor = this.model.get('factor');
        var municipality = this.model.get('municipality');
        // disable link to report about Företagsamheten for 2016, might get updated?
        // noinspection PointlessBooleanExpressionJS
        if (false && underscore_1.default(['entrepreneurship', 'new_entrepreneurship']).includes(factor) && !underscore_1.default(['', 'Sverige']).includes(municipality)) {
            var county = grouping_1.Grouping.countyFor(municipality);
            if (county) {
                var _d = county, name_1 = _d.name, slug = _d.slug;
                var link = (_a = this.reportContainer) === null || _a === void 0 ? void 0 : _a.data('reportLinks')[slug];
                (_b = this.reportContainer) === null || _b === void 0 ? void 0 : _b.html(BigChart.reportContainerTemplate({ link: link, name: name_1 }));
                return (_c = this.reportContainer) === null || _c === void 0 ? void 0 : _c.show();
            }
        }
        else {
            return this.reportContainer.hide();
        }
    };
    BigChart.prototype.updateSourceSelection = function () {
        if (!this.sourceSelection) {
            return;
        }
        if (this.model.applicableToPoliticians()) {
            return this.sourceSelection.show();
        }
        else {
            return this.sourceSelection.hide();
        }
    };
    BigChart.prototype.updateChart = function () {
        var factor = this.model.get('factor');
        var municipalities = this.model.municipalities();
        var type = this.model.get('type');
        var subseries = this.model.get('subseries');
        var excludeSweden = this.model.get('excludeSweden');
        var description = window.factorDescriptions[factor];
        var showBadgeIcon = this.model.hasIcon();
        // TODO: These seem unused today (can only find related data-allow-type-selection attributes in county related
        // TODO: files).
        var dataAllowTypeSelection = this.$el.data('allowTypeSelection');
        var dataShowSubseries = this.$el.data('showSubseries');
        var showTypeSelection = dataAllowTypeSelection && this.model.applicableToPoliticians();
        var showSubseries = dataShowSubseries && this.model.applicableToPoliticians();
        // TODO: Atrocious hack.
        window.hideSweden = false;
        // debugger;
        // on Pontus' request, hide sweden initially (for entrepreneurship that is)
        var chartHider = (function () {
            //console.log("again:" + window.hideSweden + " " + @factor + " " + !("Sverige" in municipalities) + " " + Highcharts?)
            if (!window.fromSwedenStatisticsPage && !window.hideSweden && (factor === "entrepreneurship") && !(underscore_1.default(municipalities).includes("Sverige")) && (typeof window.Highcharts !== 'undefined' && window.Highcharts !== null)) {
                var charts = underscore_1.default.filter(window.Highcharts.charts, function (c) { return !!c; });
                var series = underscore_1.default.map(charts, function (c) { return c.series; });
                series = underscore_1.default.flatten(series);
                //console.log(series.length)
                if (series.length > 0) {
                    var swSeries = underscore_1.default.filter(series, function (s) { return underscore_1.default([
                        'Sverige (Andel företagsamma individer)',
                        'Sverige (Företagsamma unga)',
                        'Sverige (Företagsamma kvinnor)'
                    ]).includes(s.name); });
                    underscore_1.default.forEach(swSeries, function (s) { return s.hide(); });
                    window.hideSweden = true;
                }
            }
        });
        if (window.hideSwedenInterval != null) {
            window.clearInterval(window.hideSwedenInterval);
        }
        window.hideSwedenInterval = window.setInterval(chartHider, 100);
        // should destroy old chart or performance suffers pretty bad after a couple of chart
        // changes
        if ((typeof window.Highcharts !== 'undefined' && window.Highcharts !== null) && (window.Highcharts.charts != null)) {
            underscore_1.default.forEach(window.Highcharts.charts, function (c) {
                if (c != null) {
                    console.log("Destroying...");
                    return c.destroy();
                }
            });
        }
        console.log("Drawing...");
        this.$el.html(BigChart.template({ factor: factor, description: description, showBadgeIcon: showBadgeIcon, showTypeSelection: showTypeSelection, showSubseries: showSubseries }));
        return charts_1.Charts.drawBigChart('big_chart_statistics', municipalities, factor, type, subseries, { excludeSweden: excludeSweden });
    };
    BigChart.template = underscore_1.default.template("\n        <div id=\"big_chart_statistics\"></div>\n    ");
    BigChart.reportContainerTemplate = underscore_1.default.template("\n        <a href=\"<%= link %>\">F\u00F6retagsamheten rapport om <%= name %></a>\n    ");
    __decorate([
        withMName_1.withMName
    ], BigChart.prototype, "setChartType", null);
    __decorate([
        withMName_1.withMName
    ], BigChart.prototype, "setSubseries", null);
    return BigChart;
}(Backbone.View));
exports.BigChart = BigChart;
